import { createFileRoute } from "@tanstack/react-router";

import { AdminMfaResetRequestsPage } from "@/presentation/pages/AdminMfaResetRequestsPage";

export const Route = createFileRoute("/admin/users/mfa-reset-requests")({
  component: AdminMfaResetRequestsPage,
});